import { createBrowserHistory } from 'history';
import { basename } from './config';

export default createBrowserHistory({ basename });
